export const DELETE_SUSPENDED_REASON_MUTATION = gql`
    mutation deleteSuspendedReason($id: Int!) {
        deleteSuspendedReason(id: $id) {
            id
        }
    }
`;

export const CREATE_SUSPENDED_REASON_MUTATION = gql`
    mutation createSuspendedReason($input: CreateSuspendedReasonInput!) {
        createSuspendedReason(input: $input) {
            description
        }
    }
`;
